<template>
  <v-app>
    <v-app-bar app>
      <NavigationVue />
    </v-app-bar>

    <!-- Sizes your content based upon application components -->

    <v-main>
      <!-- Provides the application the proper gutter -->
      <!-- If using vue-router -->
      <router-view></router-view>
    </v-main>
    <SnackbarVue />
    <LoaderVue />
    <SeguirServicioModalVue />
    <!-- <v-footer app>
    
  </v-footer> -->
  </v-app>
</template>

<script>
import LoaderVue from "./components/Loader.vue";
import NavigationVue from "./components/Navigation.vue";
import SeguirServicioModalVue from "./components/SeguirServicioModal.vue";
import SnackbarVue from "./components/Snackbar.vue";
import config from "./config";
export default {
  name: "App",
  components: {
    NavigationVue,
    SnackbarVue,
    LoaderVue,
    SeguirServicioModalVue
  },
  data: () => ({
    //
  }),
};
</script>


<style src="@/assets/styles/main.css">

</style>
